export enum columnType {
    C_XS = 'C-XS',
    C_M = 'C-M',
    C_S1S2 = 'C-S1S2',
    C_XL = 'C-XL',
    V_P3T_XL = 'V-P3T-XL',
    V_P3T_S = 'V-P3T-S',
    V_P3T_XS_M = 'V-P3T-XS_M',
    V_P4T_2M = 'V-P4T-2M',
    V_P4T_XS_S = 'V-P4T-XS-S',
    V_P4T_XS_XL = 'V-P4T-XS-XL',
    V_P5T_SM = 'V-P5T-SM',
    V_P5T_XL_M = 'V-P5T-XL-M',
    V_P5T_XS_2M = 'V-P5T-XS-2M',
    O_X4 = 'O-X4',
    O_X5 = 'O-X5',
    O_X6 = 'O-X6',
    none = 'none',
}
